export const Footer = ({ className = "" }) => (
  <footer
    data-testid="app-footer"
    className={`w-full py-4 text-center text-xs tracking-wide text-muted-foreground/80 select-none ${className}`}
  >
    Designed &amp; Developed by Lalith Kumar <span className="mx-1 opacity-50">|</span> © 2026
  </footer>
);

export default Footer;
